import React from 'react';
import { ActivityIndicator, Text, TouchableOpacity, View } from 'react-native';
import { styles } from './styles';
import { Colors } from '../../constants/Colors';
import FontAwesome6 from 'react-native-vector-icons/FontAwesome6';

interface IButtonComponent {
  title: string;
  outlined?: boolean;
  onPress?: () => void;
  width?: string;
  disabled?: boolean;
  isLoading?: boolean;
  backgroundColor?: string;
  iconName?: string;
  iconColor?: string;
  iconSize?: number;
}

const ButtonComponent = ({
  title,
  outlined,
  onPress,
  width,
  disabled,
  isLoading,
  backgroundColor,
  iconName,
  iconColor,
  iconSize,
}: IButtonComponent) => {
  const buttonStyle = {
    ...(
      outlined
        ? styles.containerOutlined
        : disabled
        ? styles.containerDisabled
        : styles.container
    ),
    width,
    ...(backgroundColor
      ? { backgroundColor, borderColor: backgroundColor } 
      : {}),
  };

  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={disabled || isLoading}
      style={buttonStyle}>
      {isLoading ? (
        <ActivityIndicator color={outlined ? Colors.RedPallete.red : '#fff'} />
      ) : (
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          {iconName && (
            <FontAwesome6
              name={iconName}
              size={iconSize ?? 16}
              color={iconColor ?? (outlined ? Colors.RedPallete.red : '#fff')}
              style={{ marginRight: 8 }}
            />
          )}
          <Text style={outlined ? styles.titleOutlined : styles.title}>
            {title}
          </Text>
        </View>
      )}
    </TouchableOpacity>
  );
};

export default ButtonComponent;
